export default __webpack_public_path__ + "static/widgets-76db2c4d44b23e10a40e4cedc9eefcdf.png";